import { Box } from '@mui/material'
import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ConsentProvider } from './contexts/ConsentContext'
import CookieConsent from './components/CookieConsent/CookieConsent'
import AppFooter from './components/AppFooter'
import 'katex/dist/katex.min.css'
import './App.css'
import router from './routes/routes'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function App() {
  return (
    <ConsentProvider>
      <CookieConsent />
      <AuthProvider>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Box component="main" sx={{ flex: 1 }}>
            <RouterProvider router={router} />
          </Box>
          <AppFooter />
        </Box>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      </AuthProvider>
    </ConsentProvider>
  )
}

export default App
